export default __webpack_public_path__ + "static/media/oopsDark.88e53f37.svg";